function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.938 5.056C6.496 3.77 8.854 2.47 12.001 2.47A9.512 9.512 0 0121.53 12a.75.75 0 01-1.5 0A8.012 8.012 0 0012 3.97c-2.707 0-4.739 1.113-6.108 2.243-.456.376-.836.752-1.14 1.086h1.54a.75.75 0 110 1.5h-3.07a.75.75 0 01-.75-.75V4.976a.75.75 0 011.5 0v.968c.28-.285.602-.587.967-.888zM3.221 11.25a.75.75 0 01.75.75A8.03 8.03 0 0012 20.03c2.168 0 3.974-1.081 5.273-2.227.432-.381.801-.763 1.1-1.102H16.83a.75.75 0 010-1.5h3.073a.75.75 0 01.75.75v3.073a.75.75 0 01-1.5 0v-.952c-.261.275-.557.566-.887.856-1.44 1.269-3.585 2.602-6.265 2.602A9.53 9.53 0 012.47 12a.75.75 0 01.75-.75z",
  fill: "#313D53"
})));